import { BigNumber } from 'bignumber.js'
import createDependableResource from 'utils/zustand/createDependableResource'
import { getCraftsmanContract } from 'utils/contractHelpers'
import { BIG_ZERO } from 'utils/bigNumber'
import { parseInt } from 'lodash'

interface TotalAllocPoint {
  totalAllocPoint: number
  totalAllocPointBn: BigNumber
}

const fetchTotalAllocPoint = async (): Promise<TotalAllocPoint> => {
  const craftsmanContract = getCraftsmanContract()
  const totalAllocPointString = (await craftsmanContract.totalAllocPoint()).toString()
  return {
    totalAllocPoint: parseInt(totalAllocPointString),
    totalAllocPointBn: new BigNumber(totalAllocPointString),
  }
}

export const useTotalAllocPoint = createDependableResource<TotalAllocPoint>({
  initValue: {
    totalAllocPoint: 0,
    totalAllocPointBn: BIG_ZERO,
  },
  getValue: fetchTotalAllocPoint,
  dependResources: [],
  dbgName: 'TotalAllocPoint',
})
